import { IContact } from '../model/contact';
import { useContactService } from '../service/contact';

const resource = 'pricelists';

const useContact = () => {
  const {
    getById,
    create,
    update,
    remove,
    ...restService
  } = useContactService();

  function getContactById(id: string) {
    return getById(id);
  }

  async function createContact(formData: IContact) {
    const response = await create(formData);
    return response;
  }

  async function updateContact(id: string, data: IContact) {
    const response = await update(id, data);
    return response;
  }

  async function deleteContact(id: string, rowVersion: string) {
    const response = await remove(id, rowVersion);
    return response;
  }

  return {
    resource,
    getContactById,
    createContact,
    updateContact,
    deleteContact,
    ...restService,
  };
};

export default useContact;
